import { render } from "./MoveItem.vue?vue&type=template&id=6edc9418"
import script from "./MoveItem.vue?vue&type=script&lang=js"
export * from "./MoveItem.vue?vue&type=script&lang=js"
script.render = render

export default script